import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { GiftTooltipContainerCss } from 'components/page/UserProfile/UserProfileGifts/GiftTooltipContainer'

export const GiftItemDescription = styled.div<{
  $left: number
  $top: number
}>`
  ${GiftTooltipContainerCss};

  left: ${({ $left }) => ($left ? `${$left}px` : 'auto')};
  top: ${({ $top }) => ($top ? `${$top}px` : 'auto')};
  display: none;
  visibility: visible;
`

export const Message = styled.div`
  overflow-wrap: anywhere;
  margin-top: 4px;
  color: ${Colors.black};
`

export const WrapperButtonSignature = styled.div`
  margin-top: 10px;
`
